import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Title } from '@angular/platform-browser';
import { EntityControllerService, EntityPickerComponent } from 'entity-picker-lib';
import { Namespace } from 'enums-lib';
import { RUNTIME_ENVIRONMENT } from 'environments-lib';
import { IPickerInfo, IRuntimeEnvironment } from 'interfaces-lib';
import { RippleDirective } from 'ripple-lib';
import { Subscription } from 'rxjs';
import { IdentityStorage } from 'storage-service-lib';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [CommonModule, MatTooltipModule, MatIconModule, EntityPickerComponent, RippleDirective],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() showEntityPicker = false;
  @Input() appName: string | undefined = undefined;
  @Input() complyTitle: string | undefined = undefined; // for Salesforce users
  originNamespace: string | undefined = undefined;
  tenantName: string | undefined = undefined;
  userLoggedIn = false;
  private identitySub?: Subscription;

  constructor(
    private entityControllerService: EntityControllerService,
    private identityStorage: IdentityStorage,
    private titleService: Title,
    @Inject(RUNTIME_ENVIRONMENT) protected runtimeEnvironment: IRuntimeEnvironment | undefined,
  ) {
    this.originNamespace = runtimeEnvironment?.origin.namespace ?? undefined;
    this.tenantName = runtimeEnvironment?.client.name ?? undefined;
  }

  get shownComplyTitle(): string | undefined {
    return this.originNamespace === Namespace.salesforce ? this.complyTitle : undefined;
  }

  ngOnInit(): void {
    this.initIdentitySub();
  }

  ngOnDestroy(): void {
    if (this.identitySub) {
      this.identitySub.unsubscribe();
    }
  }

  entitySelected(entityInfo: IPickerInfo): void {
    this.entityControllerService.entitySelected(entityInfo.entity);
  }

  private initIdentitySub(): void {
    this.identitySub = this.identityStorage.observe().subscribe((selectedIdentity) => {
      this.userLoggedIn = !!selectedIdentity?.namespace && !!selectedIdentity?.tenant && !!selectedIdentity?.token;
      if (!this.originNamespace) {
        this.originNamespace = selectedIdentity?.namespace;
      }
      if (!this.tenantName) {
        this.tenantName = selectedIdentity?.tenant;
      }
      this.updateBrowserTitle();
    });
  }

  // The tab shows the same Comply title as the header. Other datasources keep the title from index.html.
  private updateBrowserTitle(): void {
    const complyTitle = this.shownComplyTitle;
    if (complyTitle) {
      this.titleService.setTitle(complyTitle);
    }
  }
}
